var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 171.146,
    height: 165.868,
    viewBox: "0 0 171.146 165.868",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1278"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Polygon 8",
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m85.474 27.481 47.975 27.812.097 55.452-47.876 27.642-47.975-27.81-.098-55.454Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.597 55.123.098 55.453 47.975 27.81 47.876-27.64-.097-55.453L85.474 27.48 37.597 55.123m-5-8.66L80.474 18.82a10 10 0 0 1 10.016.008l47.974 27.812a10 10 0 0 1 4.985 8.634l.097 55.453a10 10 0 0 1-5 8.677L90.67 147.047a10 10 0 0 1-10.016-.008L32.68 119.226a10 10 0 0 1-4.985-8.634l-.097-55.451a10 10 0 0 1 5-8.679Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1195",
    transform: "translate(22.288 10.834)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 231",
    cx: 14.742,
    cy: 14.742,
    r: 14.742,
    transform: "translate(48.65)",
    fill: "#39beec"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 232",
    cx: 14.742,
    cy: 14.742,
    r: 14.742,
    transform: "translate(48.65 113.516)",
    fill: "#1b60a3"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 233",
    cx: 14.374,
    cy: 14.374,
    r: 14.374,
    transform: "translate(97.299 30.959)",
    fill: "#1b60a3"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 236",
    cx: 14.374,
    cy: 14.374,
    r: 14.374,
    transform: "translate(98.036 83.294)",
    fill: "#39beec"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 234",
    cx: 14.742,
    cy: 14.742,
    r: 14.742,
    transform: "translate(0 30.959)",
    fill: "#1b60a3"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 235",
    cx: 14.742,
    cy: 14.742,
    r: 14.742,
    transform: "translate(.737 83.294)",
    fill: "#39beec"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDex);
export default __webpack_public_path__ + "static/media/Dex.c81b56450f1f54887b59e23a1623e933.svg";
export { ForwardRef as ReactComponent };